import type { UseMutationOptions, UseQueryOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { CheckEmailStatus } from 'api/types/user';

interface ICheckEmailResponse {
    status: CheckEmailStatus;
}

export interface ICheckEmailProps extends UseQueryOptions<IRequestException> {
    email: string;
}

const checkEmail = async ({ email }: ICheckEmailProps) => {
    const response = await apiClient.post('signups/check-email', {
        json: { email },
    });

    return (await response.json()) as ICheckEmailResponse;
};

export const useCheckEmailMutation = (
    options: UseMutationOptions<
        ICheckEmailResponse,
        IRequestException,
        ICheckEmailProps
    >
) => {
    return useMutation<
        ICheckEmailResponse,
        IRequestException,
        ICheckEmailProps
    >(async (email) => await checkEmail(email), options);
};
